import React from 'react';
import ErrorPage from './section-components/error';

const Home_V1 = () => {
    return <div>
        <ErrorPage />
    </div>
}

export default Home_V1

